import { createAction } from 'redux-actions'
import gql from 'graphql-tag'

import client from '../services/ApolloClient'

export const requestNewsFailAction = createAction('NEWS_FAIL_FETCH')
export const requestNewsAction = createAction('NEWS_REQUEST_FETCH')
export const requestNewsSuccessAction = createAction('NEWS_SUCCESS_FETCH')

export const saveNewsFailAction = createAction('NEWS_FAIL_SAVE')
export const saveNewsAction = createAction('NEWS_REQUEST_SAVE')
export const saveNewsSuccessAction = createAction('NEWS_SUCCESS_SAVE')

export const deleteNewsFailAction = createAction('NEWS_FAIL_DELETE')
export const deleteNewsAction = createAction('NEWS_REQUEST_DELETE')
export const deleteNewsSuccessAction = createAction('NEWS_SUCCESS_DELETE')

const apiToClientFormatNews = (apiNews) => ({
  id: apiNews.id,
  title: apiNews.titulo,
  link: apiNews.link,
  date: apiNews.data
})

const clientToApiFormatNews = (news) => ({
  id: news.id,
  titulo: news.title,
  link: news.link,
  data: news.date
})

export const fetchNews = injection => {
  return dispatch => {
    dispatch(requestNewsAction())
    return client.query({
      fetchPolicy: 'no-cache',
      query: gql`
        query FetchNews {
          news(limit: 999999, page: 1) {
            id
            titulo
            link
            data
          }
        }
      `
    }).then(({ data }) => dispatch(
        requestNewsSuccessAction((data.news || []).map(apiToClientFormatNews))
      ))
      .catch(({ errors }) => dispatch(requestNewsFailAction(new Error(errors[0].message))))
  }
}

export const saveNews = (news, injection) => {
  let input = clientToApiFormatNews(news)

  return (dispatch) => {
    dispatch(saveNewsAction())
    return client.mutate({
      fetchPolicy: 'no-cache',
      mutation: gql`
        mutation SaveNews($input: CreateNewsInput!) {
          createNews(input: $input) {
            id
            titulo
            link
            data
          }
        }
      `,
      variables: { input }
    }).then(() => dispatch(saveNewsSuccessAction()))
      .catch(({ errors }) => dispatch(saveNewsFailAction(new Error(errors[0].message))))
  }
}

export const deleteNews = (id, injection) => {
  return (dispatch) => {
    dispatch(deleteNewsAction())

    return client.mutate({
      fetchPolicy: 'no-cache',
      mutation: gql`
        mutation DeleteNews($id: Int!) {
          deleteNews(id: $id) {
            ok
          }
        }
      `,
      variables: { id }
    }).then(() => dispatch(deleteNewsSuccessAction()))
      .catch(err => dispatch(deleteNewsFailAction(new Error(err))))
  }
}



// WEBPACK FOOTER //
// ./src/actions/news.js